import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useAttempt } from "../../../hooks/useAttempt";
import { useLessonDetails } from "../../../hooks/useLessonDetails";
import Editor from "../../Editor";
import CheckboxButton from "../../CheckboxButton";
import Button from "../../Button";
import LessonAPI from "../../../apis/LessonAPI";

const LessonCartaReview = ({
  courseId,
  episodeId,
  chapterId,
  lessonId,
  userId,
  onClose = () => {},
  onFinish = () => {},
}) => {
  const lesson = useLessonDetails(lessonId);

  const description = lesson?.description;
  const attempt = useAttempt(lessonId, userId);
  const state = attempt?.state || "NOT_SENDED";

  const [text, setText] = useState("");
  const [obs, setObs] = useState("");
  const [withObs, setWithObs] = useState(true);

  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (!attempt) return;

    setText(attempt.text || "");
  }, [attempt]);

  const send = () => {
    setIsSending(true);
    LessonAPI.LESSON_CARTA.evaluate(lessonId, userId, {
      observations: withObs ? obs : "",
      text,
    })
      .then(() =>
        LessonAPI.LESSON_CARTA.notify(userId, {
          courseId,
          episodeId,
          chapterId,
          lessonId,
        })
      )
      .then(() => {
        setIsSending(false);
        onFinish();
      })
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <Container>
      {description && (
        <Description
          as={Editor}
          theme={null}
          isMinimal={true}
          readOnly={true}
          value={description}
        />
      )}
      <Content>
        <CheckboxButton
          text="Con observaciones"
          checked={withObs}
          onClick={() => {
            setWithObs((state) => !state);
          }}
        />
        {withObs && (
          <ObservationsWrapper>
            <Title>Observaciones</Title>
            <Observations>
              <InputTextAreaStyled
                as={Editor}
                value={obs}
                onChange={setObs}
                placeholder="Observaciones"
                minHeight={200}
              />
            </Observations>
          </ObservationsWrapper>
        )}
        <Button
          text="Restaurar carta"
          primary
          onClick={() => setText(attempt?.text || "")}
        />
        <TinyText>
          {`*Recuerda que presionando CTRL + Z puedes retroceder\n*Recuerda que presionando CTRL + Y puedes avanzar`}
        </TinyText>
        <InputWrapper state={state}>
          <InputTextAreaStyled
            as={Editor}
            value={text}
            onChange={setText}
            placeholder="Carta"
            minHeight={200}
          />
        </InputWrapper>
      </Content>
      <Footer>
        <ButtonCancel text="Cancelar" secondary={true} onClick={onClose} />
        <ButtonSend
          text="Enviar"
          primary={true}
          onClick={send}
          loading={isSending}
        />
      </Footer>
    </Container>
  );
};

const Container = styled.div``;

const Description = styled.div`
  font-size: 0.9em;
  color: black;
  margin-bottom: 25px;
  /* white-space: pre-wrap; */
`;

const Content = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 15px;
  }
`;

const TinyText = styled.div`
  font-size: 0.9em;
  color: black;
  margin: 10px 0px;

  white-space: pre-wrap;
`;

const ObservationsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  padding: 15px;
  background-color: white;
  border-radius: 15px;
`;

const Title = styled.div`
  font-size: 1em;
  font-weight: bold;
  color: red;

  margin-bottom: 10px;
`;

const Observations = styled.div``;

const InputWrapper = styled.div`
  & b,
  & strong {
    color: black;
  }
`;

const InputTextAreaStyled = styled.div`
  /* min-height: 250px; */

  border-radius: 15px;
  background-color: white;
`;

const Footer = styled.div`
  display: flex;
  margin-top: 25px;

  & > *:not(:last-child) {
    margin-right: 15px;
  }
`;

const ButtonSend = styled(Button)`
  flex: 1.5;
`;

const ButtonCancel = styled(Button)`
  flex: 1;
`;

export default LessonCartaReview;
